import React from 'react';
export function EmotionalClose() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-70">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-71">
        <div className="bg-cream p-8 md:p-12 rounded-3xl shadow-xl border border-stone-100 relative mb-12" data-id="element-72">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-6xl text-amber-500/30 font-heading" data-id="element-73">
            "
          </div>
          <p className="text-2xl md:text-3xl font-heading text-teal-900 italic relative z-10" data-id="element-74">
            El padre que tiene un sistema puede acompañar a su hijo con calma.
            El padre sin sistema acompaña con miedo. La diferencia entre los dos
            no es el amor. Es la herramienta.
          </p>
        </div>
      </div>
    </section>;
}